import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Leaf, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import PasswordInput from "../components/PasswordInput";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        if (password.length < 6) {
            setError("Almeno 6 caratteri");
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            toast.success("Password reimpostata · Ora accedi");
            nav("/login");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setSubmitting(false);
        }
    }

    if (!token) {
        return (
            <div className="min-h-screen bg-bone grid place-items-center px-4">
                <div className="bg-white rounded-2xl shadow-sm border border-soft p-7 max-w-md w-full text-center">
                    <p className="text-stone-600">Link non valido o scaduto.</p>
                    <Link to="/forgot-password" className="text-forest hover:underline">Richiedi nuovo link</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-bone grid place-items-center px-4 py-10">
            <div className="w-full max-w-md">
                <div className="bg-white rounded-2xl shadow-sm border border-soft p-7">
                    <div className="w-14 h-14 rounded-2xl bg-forest text-white grid place-items-center mb-5">
                        <Leaf size={28} />
                    </div>
                    <h1 className="font-display text-2xl text-forest-dark mb-1">Nuova password</h1>
                    <p className="text-sm text-stone-500 mb-6">Scegli una password sicura per il tuo account.</p>

                    <form onSubmit={onSubmit} className="space-y-4">
                        <label className="block">
                            <span className="text-xs font-semibold text-stone-600 uppercase tracking-wide">Nuova password (min. 6 caratteri)</span>
                            <div className="mt-1">
                                <PasswordInput
                                    required
                                    minLength={6}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="input"
                                    data-testid="reset-password"
                                    iconLeft={<Lock size={16} />}
                                />
                            </div>
                        </label>
                        {error && <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
                        <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="reset-submit">
                            {submitting ? "Salvataggio..." : "Salva nuova password"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
